import React from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { BrowserRouter } from 'react-router-dom';
import CacheBuster from 'react-cache-buster';
import { GoogleOAuthProvider } from '@react-oauth/google';
import theme from './views/ui/Theme';
import Routes from './Routes';
import { AuthContextProvider } from './Context/AuthContext';
import packageJson from '../package.json';
import ShowProgress from './views/ui/Backdrop';

function App() {
  const isProduction = process.env.REACT_APP_NODE_ENV === 'production' || process.env.REACT_APP_NODE_ENV === 'staging';
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GCI}>
      <CacheBuster
        currentVersion={packageJson?.version}
        isEnabled={isProduction}
        isVerboseMode={false}
        loadingComponent={<ShowProgress />}
      >
        <AuthContextProvider>
          <BrowserRouter>
            <ThemeProvider theme={theme}>
              <Routes />
            </ThemeProvider>
          </BrowserRouter>
        </AuthContextProvider>
      </CacheBuster>
    </GoogleOAuthProvider>
  );
}
export default App;
